import { rankingList } from '@/mocks/movies';

export default function Ranking() {
  return (
    <section id="ranking" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-primary-300 text-xs md:text-sm font-medium tracking-wide">
              <i className="ri-fire-line" />
              人气推荐
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-background-50 text-balance">
              站内被反复提起的五个方向
            </h2>
            <p className="mt-4 text-background-200 text-sm md:text-base leading-relaxed">
              这里按题材与讨论热度列出一组示例，并说明它们各自适合什么样的观看心情。
              仅为演示推荐信息的组织方式，不代表任何平台的实时榜单。
            </p>
          </div>
          <a
            href="#catalog"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap self-start"
          >
            去片单区查看更多
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {rankingList.map((r) => (
            <article
              key={r.rank}
              className="flex gap-4 md:gap-5 rounded-lg bg-background-900/60 border border-background-800/70 p-5 md:p-6 hover:border-primary-500/60 transition-colors"
            >
              <div className="shrink-0 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-accent-500/15 text-accent-300 font-heading font-black text-xl md:text-2xl">
                {r.rank}
              </div>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <h3 className="font-heading font-semibold text-base md:text-lg text-background-50">
                    {r.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-secondary-500/20 text-secondary-300 text-[11px]">
                    {r.genre}
                  </span>
                  <span className="text-primary-300 text-xs md:text-sm font-semibold">
                    {r.rating.toFixed(1)}
                  </span>
                </div>
                <p className="mt-2.5 text-background-300 text-xs md:text-sm leading-relaxed">
                  {r.reason}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}